import ApiError from 'utils/api/errors/ApiError';


class ApiMultiDeviceError extends ApiError {
  constructor (props) {
    super(props);
    this.status = 420;
  }
}

export default ApiMultiDeviceError;
